// ui
import { Button, Typography, Modal, Box, Alert } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

// jotai
import { useWindowSize } from "../../lib/useWindowSize";

interface OutSideStartStopModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  startStopDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setStartStopDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  startStopData: () => void;
}

export function OutSideStartStopModal(props: OutSideStartStopModalProps) {
  const {
    onModal,
    swCloseModal,
    startStopDataInf,
    setStartStopDataInf,
    startStopData,
  } = props;

  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="outside-start-stop-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="cancelTitleBox"
          className="shippori-antique-regular"
        >
          公開・非公開
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {startStopDataInf.status === "open" ? (
            <>
              <Alert severity="error">
                {startStopDataInf.key.startStop == "start" ? (
                  <>
                    サイトが公開されます。
                    <br />
                    ※再開後、外部エントリー可能となります。
                  </>
                ) : startStopDataInf.key.startStop == "stop" ? (
                  <>
                    サイトが非公開されます。
                    <br />
                    ※停止後、外部エントリー不可能となります。
                    <br />
                    ※すでに登録済のエントリーに影響はありません。
                  </>
                ) : null}
              </Alert>
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                  }}
                >
                  <Button
                    data-testid="outside-start-stop-submit"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={startStopData}
                  >
                    <Box className="m-plus-rounded-1c-regular">
                      {startStopDataInf.key.startStop == "start"
                        ? "公開"
                        : "非公開"}
                    </Box>
                    {startStopDataInf.key.startStop == "start" ? (
                      <PlayCircleOutlineIcon
                        sx={{ marginLeft: "6px", color: "white" }}
                        fontSize="medium"
                      />
                    ) : (
                      <DoDisturbAltIcon
                        sx={{ marginLeft: "6px", color: "white" }}
                        fontSize="medium"
                      />
                    )}
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                  }}
                >
                  <Button
                    data-testid="outside-start-stop-close"
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : startStopDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">成功しました。</Box>
              <Box>
                <Button
                  data-testid="outside-start-stop-success-close"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : startStopDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {startStopDataInf.message}
              </Box>
              <Box>
                <Button
                  data-testid="outside-start-stop-failed-back"
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setStartStopDataInf({
                      ...startStopDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
